import importReact from "../../utils/importReact";

export default function initNewsArticles() {
  const entrypoint = document.getElementById("news-article-container");
  if (entrypoint) {
    import(/* webpackChunkName: "newsArticles" */ "./NewsArticles").then((e) => {
      const pageSize = parseInt(entrypoint.dataset.pagesize);
      const currentPageRef = parseInt(entrypoint.dataset.currentpage);
      importReact().then(([React, ReactDOM]) => {
        ReactDOM.render(
          React.createElement(e.default, { pageSize, currentPageRef }),
          entrypoint
        );
      });
    });
  }
}
